import { useEffect, useState, useRef } from "react";
import * as echarts from "echarts";

const SideStackedBarChart = ({active, downTimeData}) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null); // store chart instance

  const [siteNames, setSiteNames] = useState([]);
  const [seriesData, setSeriesData] = useState([]);

  useEffect(() => {
    if (!chartRef.current) return;

    const chart = echarts.init(chartRef.current);
    chartInstanceRef.current = chart;

    chart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      // toolbox: {
      //   show: true,
      //   feature: {
      //     mark: { show: true },
      //     dataView: { show: true, readOnly: false },
      //     saveAsImage: { show: true }
      //   }
      // },
      legend: {},
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: { type: "value"},
      yAxis: {
        type: "category",
        data: [],
      },
      series: [],
      dataZoom: [
        {
          type: 'slider',
          yAxisIndex: 0, 
          start: 0,
          end: 100,
        }
      ],
    });

    const handleResize = () => {
      chart.resize();
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, []);
  useEffect(() => {
    transformToChartSeries(downTimeData);
  }, []);
  useEffect(() => {
    if (!chartInstanceRef.current) return;

    const chart = chartInstanceRef.current;
    if (siteNames.length === 0 || seriesData.length === 0) {
      console.error("No site names or series data available to update chart");
      return;
    }

    chart.setOption({
      yAxis: {
        data: siteNames,
      },
      series: seriesData,
    });
  }, [siteNames, seriesData]);
  useEffect(() => {
    if (active && chartInstanceRef.current) {
      chartInstanceRef.current.resize();
    }
  }, [active]);
  const transformToChartSeries = (dataArray) => {
    console.log("data aray SBC", dataArray);
    if (!dataArray || dataArray.length === 0) {
      console.error("No data available to transform");
      return;
    }
    const grouped = {};
    dataArray.forEach((item) => {
      const siteName = item.siteName;
      // console.log("siteName", siteName);
      const reason = item.downcodeDescription;
      const hours = parseFloat(item.hoursDown);
      if (!grouped[reason]) grouped[reason] = {};
      if (!grouped[reason][siteName]) grouped[reason][siteName] = 0;
      grouped[reason][siteName] += hours;
    });
    console.log("object grouped", grouped);
    const siteNames = [...new Set(dataArray.map((item) => item.siteName))].sort().reverse();
    console.log("siteNames", siteNames);
    setSiteNames(siteNames);
    const dcReasons = Object.keys(grouped);
    console.log("dcReasons", dcReasons);
    const series = dcReasons.map((reason) => ({
      name: reason,
      type: "bar",
      stack: "total",
      label: { show: false },
      emphasis: { focus: "series" },
      data: siteNames.map((site) => grouped[reason][site] || 0),
    }));
    // console.log("series", series);
    setSeriesData(series);
    return;
  };
  return (
    <div
      ref={chartRef}
      style={{ width: "100%", height: "100%", minHeight: "625px" }} // Make this dynamic
    />
  );
};

export default SideStackedBarChart;
